import SiteLayout from "@/components/feature/SiteLayout";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import HotMoviesSection from "./components/HotMoviesSection";
import EditorPicks from "./components/EditorPicks";
import LatestNewsSection from "./components/LatestNewsSection";
import HomeSidebar from "./components/HomeSidebar";

export default function Home() {
  useDocumentMeta({
    title: "色虎 - 热门影视剧推荐与资讯平台",
    description:
      "色虎提供最新影视剧推荐、丰富影片分类及专业影视资讯，满足用户多样化观影需求，是您了解影视动态和精选内容的理想网站。",
    keywords: "色虎,影视推荐,电影资讯,电视剧更新,影视剧集,视频免费播放,影视资讯平台",
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryShortcuts />

      <div className="portal-container mt-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_320px]">
          <div className="min-w-0">
            <HotMoviesSection />
            <EditorPicks />
            <LatestNewsSection />
          </div>
          <div>
            <HomeSidebar />
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}